import { render, staticRenderFns } from "./StatsTeamTab.vue?vue&type=template&id=4b1bfc5a&scoped=true&"
import script from "./StatsTeamTab.vue?vue&type=script&lang=js&"
export * from "./StatsTeamTab.vue?vue&type=script&lang=js&"
import style0 from "./StatsTeamTab.vue?vue&type=style&index=0&id=4b1bfc5a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1bfc5a",
  null
  
)

export default component.exports